import { useRef, useState } from "react";
import { toast } from "sonner";
import { Loader2, Upload } from "lucide-react";
import { api, errText } from "@/lib/api";

export const MediaUpload = ({ accept = "image/*,video/*", multiple = false, onUploaded, label = "Upload", testId, className = "", uploadUrl = "/media" }) => {
  const input = useRef(null);
  const [busy, setBusy] = useState(0);

  const upload = async (files) => {
    const list = Array.from(files || []);
    if (!list.length) return;
    setBusy(list.length);
    const done = [];
    for (const f of list) {
      try {
        const fd = new FormData();
        fd.append("file", f);
        const { data } = await api.post(uploadUrl, fd);
        done.push({ id: data.id, kind: data.kind, name: data.name || f.name });
      } catch (e) {
        toast.error(`${f.name}: ${errText(e, "upload failed")}`);
      }
      setBusy((b) => b - 1);
    }
    if (done.length) onUploaded(multiple ? done : done[0]);
  };

  return (
    <>
      <button type="button" disabled={busy > 0} onClick={() => input.current?.click()} data-testid={testId}
        className={`inline-flex items-center justify-center gap-2 border border-dashed border-[#E62314] bg-white/70 px-4 py-3 text-sm font-bold transition-colors hover:bg-white disabled:opacity-60 ${className}`}>
        {busy > 0 ? <Loader2 className="h-4 w-4 animate-spin" /> : <Upload className="h-4 w-4" />}
        {busy > 0 ? `Uploading${busy > 1 ? ` (${busy} left)` : ""}…` : label}
      </button>
      <input ref={input} type="file" accept={accept} multiple={multiple} className="hidden" onChange={(e) => { upload(e.target.files); e.target.value = ""; }} />
    </>
  );
};
